import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { DatePickerTitle, FormWidgetsTitle } from "../../../../../Constants/Constants";
import DatePicker from "./DatePicker";
import DefaultCalendar from "./DefaultCalendar";
import ReactstrapCalendar from "./ReactstrapCalendar";
import TimePicker from "./TimePicker";

const DatePickerContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={DatePickerTitle} parent={FormWidgetsTitle} />
      <Container fluid>
        <Row>
          <DefaultCalendar />
          <ReactstrapCalendar />
          <DatePicker />
          <TimePicker />
        </Row>
      </Container>
    </>
  );
};

export default DatePickerContainer;
